/**
 * Production Error Handler
 * Suppress development-only errors and browser extension errors
 */

// Suppress all unwanted console errors
const originalError = console.error;
console.error = function(...args) {
    const errorStr = args.join(' ');
    
    // Filter out known development-only errors and extension errors
    if (errorStr.includes('WebSocket') || 
        errorStr.includes('vite') ||
        errorStr.includes('HMR') ||
        errorStr.includes('content.js') ||
        errorStr.includes('activateKey')) {
        return; // Suppress
    }
    
    // Log real errors
    originalError.apply(console, args);
};

// Suppress browser extension errors (content.js)
window.addEventListener('error', function(event) {
    if (event.filename && (event.filename.includes('content.js') || 
        event.filename.includes('extension') ||
        event.message.includes('activateKey'))) {
        event.preventDefault();
        return true;
    }
}, true);

// Suppress unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', function(event) {
    const errorStr = String(event.reason);
    if (errorStr.includes('content.js') || 
        errorStr.includes('WebSocket') ||
        errorStr.includes('activateKey') ||
        errorStr.includes('toLowerCase') ||
        errorStr.includes('extension')) {
        event.preventDefault();
        return true;
    }
});

// Global promise rejection handler
const originalPromiseRejection = Promise.prototype.catch;
Promise.prototype.catch = function(onRejected) {
    return originalPromiseRejection.call(this, function(error) {
        const errorStr = String(error);
        if (errorStr.includes('content.js') || 
            errorStr.includes('activateKey') ||
            errorStr.includes('toLowerCase')) {
            // Suppress extension errors
            return;
        }
        if (onRejected) {
            return onRejected(error);
        }
        throw error;
    });
};
